import { Children, ReactNode } from 'react';

interface Props {
  currentStep: number; // 1-based
  children: ReactNode;
}

// Multi-step wizard container. Renders only the child at `currentStep` (1-based).
// Optionally shows a "Step N of M — Label" indicator above the active step.
export function StepWizard({ currentStep, children }: Props) {
  const steps = Children.toArray(children);
  return <>{steps[currentStep - 1]}</>;
}
